import React from 'react';
import PropTypes from 'prop-types';

import Item from './Item';
import Wrap from './styles';

const List = ({ className, categories, toggleSubCategories, activeCategoryIndex, closeMenu }) => {
    const clickHandler = () => {
        if (window.event?.metaKey || window.event?.ctrlKey) return;
        closeMenu();
    };
    return (
        <Wrap className={className}>
            {categories.map((category, index) => (
                <Item
                    isActiveCategory={activeCategoryIndex === index}
                    categoryIndex={index}
                    permalink={category.permalink}
                    key={category.id}
                    onClick={clickHandler}
                    name={category.name}
                    iconPath={category.icon_svg_path}
                    toggleSubCategories={toggleSubCategories}
                    subcategories={category.children}
                />
            ))}
        </Wrap>
    );
};

List.propTypes = {
    className: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.object),
    toggleSubCategories: PropTypes.func,
    closeMenu: PropTypes.func,
    activeCategoryIndex: PropTypes.number,
};

List.defaultProps = {
    className: '',
    categories: [],
    toggleSubCategories: () => {},
    closeMenu: () => {},
    activeCategoryIndex: null,
};

export default List;
